import { ActionRefundInfoTypes, SET_REFUND_INFO } from './actions';
import { RefundInfoFragment } from '@websky/graphql';

const initialState: RefundInfoFragment = null;

function refundInfoReducer(state = initialState, { type, payload }: ActionRefundInfoTypes) {
	switch (type) {
		case SET_REFUND_INFO:
			return payload;
		default:
			return state;
	}
}

export default refundInfoReducer;
